<template>
	<div
		class="px-4 sm:px-6 lg:px-6 py-6 bg-gray-100 flex-grow flex flex-col space-y-6"
	>
		<p class="mt-2 text-2xl text-black font-medium mx-auto text-center">
			<span v-if="locale == 'de'">
				Hier werden Ihre unverbindlichen Ein- und/oder Verkaufsinserate
				angezeigt.
			</span>
			<span v-else>
				Your free buy and sell offers will be displayed here.
			</span>
		</p>

		<ui-button
			type="primary"
			class="mt-2 text-lg mx-auto block"
			v-on:click="$bus.$emit('toggle-iframe-modal', $route('offers.create'))"
		>
			<span class="flex items-center">
				<ui-icon name="plus" class="h-7 w-7" stroke-width="2" />
				{{ __("New offer") }}
			</span>
		</ui-button>
		<div class="mt-2 text-2xl text-gray-500 font-medium mx-auto text-center">
			<span v-if="locale == 'de'">
				Warum inserieren? Wir haben da drei Ideen:
			</span>
			<span v-else> Why advertise? We have three ideas: </span>
		</div>

		<div class="md:px-12">
			<div class="flex flex-col sm:flex-row items-stretch justify-center">
				<div
					class="flex-1 md:mx-6 px-6 py-6 rounded-2xl border border-black m-2"
				>
					<div class="flex items-center space-x-4 pb-4 h-12">
						<ui-icon
							name="fa-magnifying-glass"
							stroke-width="2"
							class="flex items-center"
						/>
						<h2 class="text-2xl font-semibold">Sichtbarkeit</h2>
					</div>

					<p>
						Inserieren Sie Ihre Ware und zeigen Sie sich potentiellen
						Handelspartnern. Passende Nachfragen zu Ihren Inseraten werden Ihnen
						automatisch vorgeschlagen
					</p>

					<div class="flex items-center space-x-2 py-3">
						<ui-icon
							class="h-5 w-5 text-orange-500"
							name="fa-arrow-right"
							stroke-width="2.5"
						/>
						<a
							:href="$route('search.index')"
							class="text-orange-500 underline cursor-pointer"
						>
							Aktuelle Nachfragen ansehen
						</a>
					</div>
				</div>

				<div
					class="flex-1 md:mx-6 px-6 py-6 rounded-2xl border border-black m-2"
				>
					<div class="flex items-center space-x-4 pb-4 h-12">
						<ui-icon
							name="fa-list-check"
							stroke-width="2"
							class="flex items-center"
						/>
						<h2 class="text-2xl font-semibold">Management</h2>
					</div>

					<p>
						Organisieren Sie bequem Ihre Vermarktung über cropspot. Haben Sie
						stets im Blick, welche Bestände Sie noch zu vermarkten haben und
						welche Ware Sie schon verkauft haben.
					</p>

					<div class="flex items-center space-x-2 py-3">
						<ui-icon
							class="h-5 w-5 text-orange-500"
							name="fa-arrow-right"
							stroke-width="2.5"
						/>
						<page-link
							:href="$route('my_contracts.index')"
							:cta="{ code: 402, view: 'views/Modal/PremiumRequired' }"
							:absolute="true"
							class="text-orange-500 underline cursor-pointer"
						>
							Kontraktübersicht ansehen
						</page-link>
					</div>
				</div>

				<div
					class="flex-1 md:mx-6 px-6 py-6 rounded-2xl border border-black m-2"
				>
					<div class="flex items-center space-x-4 pb-4 h-12">
						<ui-icon name="hammer" stroke-width="2" class="flex items-center" />
						<h2 class="text-2xl font-semibold">Auktion</h2>
					</div>

					<p>
						Nehmen Sie über Ihre Inserate an unseren wöchentlichen Auktionen teil.
						Einfach Menge und Wunschpreis auswählen und los gehts!
					</p>

					<div class="flex items-center space-x-2 py-3">
						<ui-icon
							class="h-5 w-5 text-orange-500"
							name="fa-arrow-right"
							stroke-width="2.5"
						/>
						<a
							href="#"
							v-on:click="
								$bus.$emit('modal:open', {
									view: {
										view: 'views/Modal/Auction'
									},
								})
							"
							class="text-orange-500 underline cursor-pointer"
						>
							Mehr über die Auktion erfahren
						</a>
					</div>
				</div>
			</div>

			<div class="mt-6 border-t-2 border-dotted">
				<img :src="imageUrl" class="mx-auto mt-8 opacity-50" />
			</div>
		</div>
	</div>
</template>

<script>
export default {
	computed: {
		imageUrl() {
			return window.baseUrl + "/images/my-lots-empty-sample-content.png";
		},
	},
};
</script>
